const sysMessage = {
  getMessageList: '/manage/shop/shop/getMessageList', // 获取店铺消息列表
  readMessage: '/manage/shop/shop/readMessage', // 阅读店铺消息
  delMessage: '/manage/shop/shop/delMessage ' //  删除店铺消息
}
export default sysMessage



// WEBPACK FOOTER //
// ./src/service/basic/sysMessage.js